export default __webpack_public_path__ + "static/media/ic-timer.16cf7d70.svg";